import { useContext } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next/pages'
import { Button } from '@boltenergy-be/design-system'
import { routes } from 'utils/routes'
import { ProducerCtaProps } from 'components/producers/producer-cta/types'
import { ProducerModalContext } from 'features/producer-detail/context'
import { setSelectedProducer } from 'store/app/slice'
import { useStoreDispatch, useStoreSelector } from 'hooks/store'
import useSelectInputGroup from 'hooks/useSelectInputGroup'
import { InputGroupKeys } from 'store/customer/enums'
import { startSimulationOrRegistration } from 'utils/customerFlow'
import { SIMULATION_TYPES, SimulationType } from '@boltenergy-be/shared'
import { useGetLanguage } from 'hooks/useGetLanguage'

const ProducerCta = ({ capacityState, isProducerDetail, isReserved, producerSlug, simulationSalesOffice }: ProducerCtaProps) => {
  // Redux store
  const { isLoading, didSimulation } = useStoreSelector((store) => store.customer.flows.simulation)
  const { chosenSimulationType } = useSelectInputGroup(InputGroupKeys.SIMULATION)
  const simulationCompleted = didSimulation || isLoading
  const dispatch = useStoreDispatch()

  // Next router
  const router = useRouter()

  // i18n
  const { t } = useTranslation(['producer', 'producers'])
  const language = useGetLanguage()

  // Context (from ProducerDetail)
  const { setProducerModalOpen } = useContext(ProducerModalContext)

  if (isReserved) {
    return (
      <Button isFullwidth disabled>
        {t(($) => $.status.reserved)}
      </Button>
    )
  }

  if (capacityState.soldOut) {
    return (
      <Button isFullwidth disabled>
        {t(($) => $.status.soldOut)}
      </Button>
    )
  }

  if (isProducerDetail && !simulationCompleted) {
    return (
      <Button
        onClick={(e) => {
          e.stopPropagation()
          dispatch(setSelectedProducer({ producerSlug }))
          if (setProducerModalOpen) setProducerModalOpen(false)
          void startSimulationOrRegistration({ simulationSalesOffice })
        }}
        isFullwidth
        loading={isLoading}
      >
        {t(($) => $.chooseLocation)}
      </Button>
    )
  }

  return (
    <Button
      onClick={(e) => {
        e.stopPropagation()
        dispatch(setSelectedProducer({ producerSlug }))

        if (
          simulationCompleted ||
          !([SIMULATION_TYPES.pricingSimulation, SIMULATION_TYPES.express] as SimulationType[]).includes(chosenSimulationType)
        ) {
          return router.push(routes(language, producerSlug).registration)
        } else {
          void startSimulationOrRegistration({ simulationSalesOffice })
        }
      }}
      isFullwidth
      loading={isLoading}
    >
      {t(($) => $.choose)}
    </Button>
  )
}

export default ProducerCta
